import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { makeStyles } from '@material-ui/styles';
import { Box, Divider, List, Typography, Tooltip, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

// project imports
import NavItem from './../NavItem';
import NavCollapse from './../NavCollapse';

// style constant
const useStyles = makeStyles((theme) => ({
    menuCaption: {
        ...theme.typography.menuCaption
    },
    subMenuCaption: {
        ...theme.typography.subMenuCaption
    },
    menuDivider: {
        marginTop: '2px',
        marginBottom: '10px'
    }
}));

//-----------------------|| SIDEBAR MENU LIST GROUP ||-----------------------//

const NavGroup = ({ item }) => {
    const classes = useStyles();

    // menu list collapse & items
    const items = (item.children ?? []).map((menu) => {
        switch (menu.type) {
            case 'collapse':
                return <NavCollapse key={menu.id} menu={menu} level={1} />;
            case 'item':
                return <NavItem key={menu.id} item={menu} level={1} />;
            default:
                return (
                    <Typography key={menu.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return (
        <React.Fragment>
            <List sx={{ position: 'relative', py: 0 }}>
                {item.onDismiss && (
                    <Tooltip title="Unpin project">
                        <IconButton
                            size="small"
                            onClick={item.onDismiss}
                            sx={{ position: 'absolute', top: 4, right: 8, zIndex: 1, color: '#bbb', p: 0.25 }}
                        >
                            <CloseIcon style={{ fontSize: '0.9rem' }} />
                        </IconButton>
                    </Tooltip>
                )}
                {items}
            </List>

            {/* group divider */}
            <Divider sx={{ my: 1, mx: 1.5, opacity: 0.4 }} />
        </React.Fragment>
    );
};

NavGroup.propTypes = {
    item: PropTypes.object
};

export default NavGroup;
